import { render, staticRenderFns } from "./cis2.vue?vue&type=template&id=2ec6dca5&scoped=true"
import script from "./cis2.vue?vue&type=script&lang=js"
export * from "./cis2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec6dca5",
  null
  
)

export default component.exports